export enum BrandType {
    Main = 1,
    School = 2
}
